import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Button,
  Modal,
  Typography,
  Dropdown,
  Avatar,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LaptopOutlined, NotificationOutlined } from "@ant-design/icons";
import { Dashboard } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "./layout.css";
import { Box, Drawer, IconButton } from "@mui/material";
import banner from "../../images/Portal-Banner.png";
import {
  clearAllSessionStorage,
  getSessionStorage,
} from "../../helpers/session_storage";

const { Header, Content } = Layout;

const CustomLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState("1");
  const [user, setUser] = useState({});

  const handleLogout = () => {
    clearAllSessionStorage();
    navigate("/");
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Are you sure you want to Logout?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleLogout();
      },
      onCancel() {},
    });
  };

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const handleMenuClick = (key) => {
    setSelectedKey(key);
    toggleDrawer(false)();
  };
  useEffect(() => {
    // Map the current path to a menu key
    const pathToKey = {
      "/officer/dashboard": "1",
      "/officer/olmms-dashboard": "2",
      "/officer/olgprs-dashboard": "6",
      "/officer/ocmms-dashboard": "3",
      "/officer/biomedical-dashboard": "4",
      "/officer/ohs-dashboard": "5",
      "/officer/aqi-dashboard": "7",
      "/officer/software-info": "8",
    };
    setSelectedKey(pathToKey[location.pathname] || "1");
  }, [location.pathname]);
  const renderMenuItems = () => (
    <>
      <Menu.Item
        key="1"
        icon={<Dashboard />}
        onClick={() => handleMenuClick("1")}
      >
        <Link to="/officer/dashboard">Over All Dash Board</Link>
      </Menu.Item>
      <Menu.Item
        key="2"
        icon={<LaptopOutlined />}
        onClick={() => handleMenuClick("2")}
      >
        <Link to="/officer/olmms-dashboard">OLMMS</Link>
      </Menu.Item>
      <Menu.Item
        key="6"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("6")}
      >
        <Link to="/officer/olgprs-dashboard">OLGPRS</Link>
      </Menu.Item>
      <Menu.Item
        key="3"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("3")}
      >
        <Link to="/officer/ocmms-dashboard">OCMMS</Link>
      </Menu.Item>
      <Menu.Item
        key="4"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("4")}
      >
        <Link to="/officer/biomedical-dashboard">Bio Medical Waste</Link>
      </Menu.Item>
      <Menu.Item
        key="5"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("5")}
      >
        <Link to="/officer/ohs-dashboard">OHS</Link>
      </Menu.Item>
      <Menu.Item
        key="7"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("7")}
      >
        <Link to="/officer/aqi-dashboard">AQI</Link>
      </Menu.Item>
      <Menu.Item
        key="8"
        icon={<NotificationOutlined />}
        onClick={() => handleMenuClick("8")}
      >
        <Link to="/officer/software-info">Software Info</Link>
      </Menu.Item>
    </>
  );
  const menu = (
    <Menu>
      <Menu.Item disabled key="designation">
        <Typography.Text type="secondary">
          {(user?.designation_name ?? "DESIGNATION") +
            " / " +
            (user?.deeoffice_name ||
              user?.squad_name ||
              user?.taluk_name ||
              "CORPERATE")}
        </Typography.Text>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            style={{ paddingInline: "15px", fontSize: "15px", width: "100%" }}
            onClick={showDeleteConfirm}
          >
            Logout
          </Button>
        </div>
      </Menu.Item>
    </Menu>
  );
  useEffect(() => {
    const storedUser = getSessionStorage("user");
    console.log(storedUser);

    if (storedUser) {
      setUser(storedUser);
    }
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        className="header"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <IconButton
          sx={{
            display: { md: "none", xs: "flex" },
          }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon sx={{ color: "#ffffff" }} />
        </IconButton>
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            backgroundColor: "#001529",
          }}
        >
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[selectedKey]}
            style={{ flex: 1 }}
          >
            {renderMenuItems()}
          </Menu>
        </Box>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          sx={{
            "& .MuiDrawer-paper": { backgroundColor: "#001529", color: "#fff" },
          }}
        >
          <Box sx={{ width: 250 }} role="presentation">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: 2,
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <img src={banner} alt="Admin Logo" style={{ width: 150 }} />
              <IconButton onClick={toggleDrawer(false)}>
                <CloseIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{ flex: 1 }}
            >
              {renderMenuItems()}
            </Menu>
          </Box>
        </Drawer>
        <Dropdown overlay={menu} trigger={["click"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src="https://p7.hiclipart.com/preview/636/702/321/computer-icons-user-profile-avatar-black-man.jpg"
              size={30}
              style={{ cursor: "pointer" }}
            />
            <Typography.Text
              strong
              style={{ marginLeft: 8, cursor: "pointer", color: "#fff" }}
            >
              {user.name ?? "John Doe"}
            </Typography.Text>
          </div>
        </Dropdown>
      </Header>
      <Layout>
        <Layout>
          <Content
            className="site-layout-background"
            style={{
              margin: 0,
              minHeight: 280,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default CustomLayout;
